import { Terms, TermsCategory } from '@/api/terms.types';
import { EventRequiredTerms, isEventRequiredTerms } from '../types/terms';
import { useState } from 'react';

export default function useEventRequiredState(terms: Terms[]) {
  return useState(
    terms.reduce<EventRequiredTerms>(
      (acc, terms) => {
        if (isEventRequiredTerms(terms.category)) {
          acc[terms.category] = terms.isAgreed;
        }

        return acc;
      },
      {
        [TermsCategory.INFO_COLLECTION]: true,
        [TermsCategory.RECEIVE_MARKETING_INFO]: true,
      },
    ),
  );
}
